(function($) {
  function mobileFilters() {
    function openFilter() {
      $('body').addClass('reveal-mobile-filters');
    }
    
    function closeFilter() {
      $('body').removeClass('reveal-mobile-filters');
    }    

    // Filter open
    $(document).on('click', '.filters-mobile .open-filter-menu', function(e) {
      openFilter();
    });    

    
    // Filter close
    $(document).on('click', '.filters-mobile .btn-close', function(e) {
      closeFilter();
    });
    
    // Tag group accordion
    $(document).on('click', '.filters-mobile span[class*="icon-"]', function(e) {
      $(e.currentTarget).closest('.tags').toggleClass('hide');
    });    
  }
  
  function searchFocus() {
    $('.inline-search input[type="text"]').on('focus', function(e) {
      var placeholderText = $(this).attr('placeholder') || $(this).attr('data-placeholder-text');
      $(this).attr('data-placeholder-text', placeholderText);
      $(this).attr('placeholder', '');
    });
    
    $('.inline-search input[type="text"]').on('blur', function(e) {
      if ($(this).val() === '') {
        var placeholderText = $(this).attr('data-placeholder-text');
        $(this).attr('placeholder', placeholderText);
      }
    });    
  }
  
  $(document).ready(function() {
    mobileFilters();
    searchFocus();
  });
})(jQuery);

function addFilterQuerySize(x) {
  var queryHold = document.getElementById('queryHold').value;
  if (x == queryHold) {
       	document.getElementById('filter_'+queryHold).innerHTML =  queryHold;      
      	document.getElementById('filter_'+queryHold).style.color = '#637381';
      	document.getElementById('mfilter_'+queryHold).innerHTML = queryHold;      
      	document.getElementById('mfilter_'+queryHold).style.color = '#637381';  
	    document.getElementById('queryHold').value = '';
	    return;
  }
  if (queryHold) {
      	document.getElementById('filter_'+queryHold).innerHTML =  queryHold;      
      	document.getElementById('filter_'+queryHold).style.color = '#637381';
      	document.getElementById('mfilter_'+queryHold).innerHTML = queryHold;      
      	document.getElementById('mfilter_'+queryHold).style.color = '#637381';       
  }
  document.getElementById('queryHold').value = x;
  document.getElementById('filter_'+x).innerHTML = x + ' <span class="x">x</span> ';
  document.getElementById('filter_'+x).style.color = '#e94b3f';
  document.getElementById('mfilter_'+x).innerHTML = x + ' <span class="x">x</span> ';
  document.getElementById('mfilter_'+x).style.color = '#e94b3f';     
}
function addFilterQueryColor(x) {
  var queryHold = document.getElementById('queryHold2').value;
  var swatch = '<span id="swatch'+x+'" class="swatchDot"></span>';
  if (x == queryHold) {
        var swatch2 = '<span id="swatch'+queryHold+'" class="swatchDot"></span>';
      	document.getElementById('filter_'+queryHold).innerHTML =  swatch2 + ' ' + queryHold;      
      	document.getElementById('filter_'+queryHold).style.color = '#637381';
      	document.getElementById('mfilter_'+queryHold).innerHTML = swatch2 + ' ' + queryHold;      
      	document.getElementById('mfilter_'+queryHold).style.color = '#637381';   
	    document.getElementById('queryHold2').value = '';
	    return;
  }  
  if (queryHold) {
        var swatch2 = '<span id="swatch'+queryHold+'" class="swatchDot"></span>';
      	document.getElementById('filter_'+queryHold).innerHTML =  swatch2 + ' ' + queryHold;      
      	document.getElementById('filter_'+queryHold).style.color = '#637381';
      	document.getElementById('mfilter_'+queryHold).innerHTML = swatch2 + ' ' + queryHold;      
      	document.getElementById('mfilter_'+queryHold).style.color = '#637381';       
  }
  document.getElementById('queryHold2').value = x;
  document.getElementById('filter_'+x).innerHTML = swatch + ' ' + x + ' <span class="x">x</span> ';
  document.getElementById('filter_'+x).style.color = '#e94b3f';
  document.getElementById('mfilter_'+x).innerHTML = swatch + ' ' + x + ' <span class="x">x</span> ';
  document.getElementById('mfilter_'+x).style.color = '#e94b3f';     
}

function addFilterQuery(x, y) {
	var queryHold = document.getElementById('queryHold').value;
	var patt=new RegExp((' '+x+' '), "");
	var result=patt.test(queryHold);
  	var displayX;
  	var swatch='';
    if (y == 1) {
        if (x == 'over-200') {
          displayX = 'OVER $200';
        } else {
          displayX = '$'+x; 
        }
    } else if (y == 2) {
        swatch = '<span id="swatch'+x+'" class="swatchDot"></span>';
        displayX = x;
    } else {
        displayX = x;
    }
  	if (result == true) {
		var n=queryHold.replace((' '+x+' '),"");
		document.getElementById('queryHold').value=n;
      	document.getElementById('filter_'+x).innerHTML = swatch + ' ' + displayX;      
      	document.getElementById('filter_'+x).style.color = '#637381';
      	document.getElementById('mfilter_'+x).innerHTML = swatch + ' ' + displayX;      
      	document.getElementById('mfilter_'+x).style.color = '#637381';      
	} else {
		document.getElementById('queryHold').value = queryHold = queryHold + ' ' + x + ' ';
      	document.getElementById('filter_'+x).innerHTML = swatch + ' ' + displayX + ' <span class="x">x</span> ';
	    document.getElementById('filter_'+x).style.color = '#e94b3f';
      	document.getElementById('mfilter_'+x).innerHTML = swatch + ' ' + displayX + ' <span class="x">x</span> ';
	    document.getElementById('mfilter_'+x).style.color = '#e94b3f';      
	}
}
function applyFilterSelections() {
  	var queryHold = document.getElementById('queryHold').value;
    var queryHold2 = document.getElementById('queryHold2').value;
  	/*var tagAr = queryHold.split(" ");
  	var arrayLength = tagAr.length;
    var tagappend ='';

   for (var i = 0; i < arrayLength; i++) {
      var thetag = tagAr[i];
      
      if (thetag) {
        if (tagappend !== '') {
         	tagappend=tagappend+'+'+thetag; 
        } else {
          	tagappend=thetag;
        }

      }
    }*/
  var tagappend;
  if (queryHold && queryHold2) {
   	 tagappend = queryHold + '+' + queryHold2;
  } else {
    if (queryHold) {
      	tagappend = queryHold;
    }
    if (queryHold2) {
      	tagappend = queryHold2;
    }
  }
  	
  	var theloc = document.getElementById('baseCollectionURL').value;
  	location.href=theloc+'/'+tagappend;
  	
  	
}
function clearFilterSelections() {
	var theloc = document.getElementById('baseCollectionURL').value;
	location.href=theloc;  	
}

/* called within theme.js to determine if any filter menu open is not and display apply/reset accordingly */
function toggleBtns() {
  if(
    	document.getElementById('dtSize').style.display == 'none'
    	&& document.getElementById('dtPrice').style.display == 'none'
    	&& document.getElementById('dtColor').style.display == 'none'
    ) {
    document.getElementById('desktopFilterBtns').style.display = 'none';
  } else {
    document.getElementById('desktopFilterBtns').style.display = 'inline-block';   
  }
}